"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketServerConnection = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const IConnection_1 = require("../IConnection");
const utils_1 = require("@streamr/utils");
const AbstractWebsocketClientConnection_1 = require("./AbstractWebsocketClientConnection");
const Connection_1 = require("../Connection");
const logger = new utils_1.Logger(module);
class WebsocketServerConnection extends eventemitter3_1.default {
    connectionId;
    connectionType = IConnection_1.ConnectionType.WEBSOCKET_SERVER;
    resourceURL;
    remoteIpAddress;
    socket;
    stopped = false;
    constructor(socket, resourceURL, remoteAddress) {
        super();
        this.onMessage = this.onMessage.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onError = this.onError.bind(this);
        this.resourceURL = resourceURL;
        this.connectionId = (0, Connection_1.createRandomConnectionId)();
        this.remoteIpAddress = remoteAddress;
        socket.on('message', this.onMessage);
        socket.on('close', this.onClose);
        socket.on('error', this.onError);
        this.socket = socket;
    }
    // use a getter to make it possible to mock the value in tests
    getRemoteIpAddress() {
        return this.remoteIpAddress;
    }
    onMessage(message, isBinary) {
        if (!isBinary) {
            logger.trace('Received string Message');
        }
        else {
            logger.trace('Websocket server received Message');
            this.emit('data', new Uint8Array(message));
        }
    }
    onClose(reasonCode, description) {
        logger.trace('Peer ' + this.remoteIpAddress + ' disconnected.');
        this.doDisconnect(reasonCode, description);
    }
    onError(error) {
        this.emit('error', error.name);
    }
    stopListening() {
        this.socket?.off('message', this.onMessage);
        this.socket?.off('close', this.onClose);
        this.socket?.off('error', this.onError);
    }
    doDisconnect(reasonCode, description) {
        this.stopped = true;
        this.stopListening();
        this.socket = undefined;
        const gracefulLeave = (reasonCode === AbstractWebsocketClientConnection_1.GOING_AWAY) || (reasonCode === AbstractWebsocketClientConnection_1.CUSTOM_GOING_AWAY);
        this.emit('disconnected', gracefulLeave, reasonCode, description);
    }
    send(data) {
        // TODO: no need to check this.socket as it is always defined when stopped is false?
        if (!this.stopped && this.socket) {
            this.socket.send(data, { binary: true });
        }
        else {
            logger.debug('Tried to call send() on a stopped socket');
        }
    }
    async close(gracefulLeave) {
        this.emit('disconnected', gracefulLeave, undefined, 'close() called');
        this.removeAllListeners();
        if (!this.stopped) {
            this.socket?.close(gracefulLeave ? AbstractWebsocketClientConnection_1.GOING_AWAY : undefined);
        }
        else {
            logger.debug('Tried to close a stopped connection');
        }
    }
    // TODO could rename to "closeSilently?"
    destroy() {
        if (!this.stopped) {
            this.removeAllListeners();
            if (this.socket) {
                this.stopListening();
                this.socket.close();
                this.socket = undefined;
            }
            this.stopped = true;
        }
        else {
            logger.debug('Tried to destroy() a stopped connection');
        }
    }
}
exports.WebsocketServerConnection = WebsocketServerConnection;
//# sourceMappingURL=WebsocketServerConnection.js.map